import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type GetUserAppConfigQueryVariables = Types.Exact<{
   [key: string]: never
}>

export type GetUserAppConfigQuery = {
   __typename?: 'Query'
   getUserAppConfig: {
      __typename?: 'UserAppConfig'
      name: string
      activePluginEnums: Array<Types.PluginType>
      pipelines: Array<{
         __typename?: 'BasePipeline'
         pipelineId: string
         name: string
         displayName: string
         pipelineItemType: Types.PipelineItemType
         pipelineItemTemplateId: string
         isAdvancedAnalyticsEnabled: boolean
         isWhatsappConsentRequired: boolean
         color?: string | null
         pipelineIconId?: string | null
         isTasksFeatureEnabled: boolean
         isActivitiesFeatureEnabled: boolean
         stageTransitionStyle: Types.PipelineStageTransitionUiStyle
         pipelineItemTemplateConfig: {
            __typename?: 'PipelineItemTemplateConfig'
            stageFieldId: string
            displayStageFieldId?: string | null
         }
      }>
      taskCallStatusOptions: Array<{
         __typename?: 'TaskCallStatusOptionConfig'
         color: Types.ColorEnum
         option: string
      }>
      callingPermissions:
         | {
              __typename?: 'CallingPermissions'
              allowedCallingType: Types.OutBoundCallType
              allowDirectCallingForFailedCloudCalling?: Types.FailedCallType | null
           }
         | { __typename?: 'NoCallingPermission'; message?: string | null }
      pipelineActivitiesInitiateLeadPermissions: Array<{
         __typename?: 'PipelineActivityTemplateIds'
         pipelineId: string
         activityTemplateIds: Array<string>
      }>
      pipelineWisePersonalWhatsappMessageStatus: Array<{
         __typename?: 'PipelinePersonalWhatsAppMessagePermissionStatus'
         pipelineId: string
         hasPersonalWhatsappMessagePermission: boolean
      }>
      accountFeatures: Array<{
         __typename?: 'CrmAccountFeature'
         feature: Types.CrmAccountFeatureEnum
         isDisabled: boolean
      }>
      pipelineWiseFeatures: Array<{
         __typename?: 'PipelineWiseFeatures'
         pipelineId: string
         features: Array<{
            __typename?: 'CrmPipelineFeature'
            pipelineId: string
            feature: Types.CrmPipelineFeatureEnum
            isDisabled: boolean
         }>
      }>
      userPropertiesTemplate: {
         __typename?: 'UserPropertiesTemplate'
         accountId: string
         userPropertiesTemplateId: string
      }
      kmlFiles: Array<{
         __typename?: 'FileUploaderUrlResponse'
         fileId: string
         name?: string | null
         mimeType: string
         sizeInBytes: number
         url: string
      }>
      officerSharedKmlFiles: Array<{
         __typename?: 'FileUploaderUrlResponse'
         fileId: string
         name?: string | null
         mimeType: string
         sizeInBytes: number
         url: string
      }>
   }
}

export const GetUserAppConfigDocument = gql`
   query getUserAppConfig {
      getUserAppConfig {
         ... on UserAppConfig {
            name
            pipelines {
               pipelineId
               name
               displayName
               pipelineItemType
               pipelineItemTemplateId
               isAdvancedAnalyticsEnabled
               isWhatsappConsentRequired
               color
               pipelineIconId
               isTasksFeatureEnabled
               isActivitiesFeatureEnabled
               pipelineItemTemplateConfig {
                  stageFieldId
                  displayStageFieldId
               }
               stageTransitionStyle
            }
            taskCallStatusOptions {
               color
               option
            }
            callingPermissions {
               ... on CallingPermissions {
                  allowedCallingType
                  allowDirectCallingForFailedCloudCalling
               }
               ... on NoCallingPermission {
                  message
               }
            }
            pipelineActivitiesInitiateLeadPermissions {
               pipelineId
               activityTemplateIds
            }
            activePluginEnums
            pipelineWisePersonalWhatsappMessageStatus {
               pipelineId
               hasPersonalWhatsappMessagePermission
            }
            accountFeatures {
               feature
               isDisabled
            }
            pipelineWiseFeatures {
               pipelineId
               features {
                  pipelineId
                  feature
                  isDisabled
               }
            }
            userPropertiesTemplate {
               accountId
               userPropertiesTemplateId
            }
            kmlFiles {
               fileId
               name
               mimeType
               sizeInBytes
               url
            }
            officerSharedKmlFiles {
               fileId
               name
               mimeType
               sizeInBytes
               url
            }
         }
      }
   }
`
export type GetUserAppConfigQueryResult = Apollo.QueryResult<
   GetUserAppConfigQuery,
   GetUserAppConfigQueryVariables
>
